//#region components/chip/chip_constants.js
var e = {
	xs: "d-chip__label--xs",
	sm: "d-chip__label--sm",
	md: ""
}, t = {
	xs: "d-chip__close--xs",
	sm: "d-chip__close--sm",
	md: ""
}, n = {
	xs: "200",
	sm: "200",
	md: "200"
}, r = {
	CHIP_SIZE_MODIFIERS: e,
	CHIP_CLOSE_BUTTON_SIZE_MODIFIERS: t,
	CHIP_ICON_SIZES: n
};
//#endregion
export { t as CHIP_CLOSE_BUTTON_SIZE_MODIFIERS, n as CHIP_ICON_SIZES, e as CHIP_SIZE_MODIFIERS, r as default };

//# sourceMappingURL=chip-constants.js.map